import { DashboardDoughnutResource } from "@/models/homePage";
import { FC } from "react";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";

interface IHomePageDoughnut {
    doughnutData: DashboardDoughnutResource | null;
}

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    Tooltip,
    Legend
);

const HomePageDoughnut: FC<IHomePageDoughnut> = (props: IHomePageDoughnut) => {
    const doughnutOptions = {
        responsive: true,
        plugins: {
            tooltip: {
                enabled: false,
            },
        },
    };

    const doughnutValue = {
        used: {
            percent: props.doughnutData?.usedPercent,
            color: "#F1B670",
            borderRadius: props.doughnutData?.usedPercent === 100 ? 0 : 15,
        },
        left: {
            percent: props.doughnutData?.leftPercent,
            color: "#F1B67066",
            borderRadius: 0,
        },
    };

    const doughnutData = {
        datasets: [
            {
                label: "%",
                data: [doughnutValue.left.percent, doughnutValue.used.percent],
                backgroundColor: [doughnutValue.left.color, doughnutValue.used.color],
                borderColor: [doughnutValue.left.color, doughnutValue.used.color],
                borderRadius: [doughnutValue.left.borderRadius, doughnutValue.used.borderRadius],
                borderWidth: [2, 8],
                circumference: 361,
                cutout: "80%",
                rotation: 40,
            },
        ],
    };

    return (
        <div className="hp-doughnut-size">
            <Doughnut data={doughnutData} options={doughnutOptions} />
        </div>
    );
};

export default HomePageDoughnut;
